export default "__VITE_ASSET__CQ_$7u82__"